import extend from 'lodash/extend';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	data: null,
	loading: false,
	error: null,
};

const { actions, reducer } = createSlice({
	name: 'sdk',
	initialState,
	reducers: {
		getSDK: (state) => extend(state, { loading: true, error: null }),
		getSDKFailure: (state, { payload }) =>
			extend(state, { loading: false, error: payload }),
		getSDKSuccess: (state, { payload }) =>
			extend(state, { loading: false, error: null, data: payload }),
	},
});

export const { getSDK, getSDKSuccess, getSDKFailure } = actions;

export { default as sdkSaga } from './sagas';

export default reducer;
